
riot.tag2('parameter-group-new-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Добавить/изменить группу параметров</div>\n    </yield>\n    <yield to="body">\n      <loader if="{loader}"></loader>\n      <form if="{!loader}" onchange="{change}" onkeyup="{change}">\n        <div class="row">\n          <div class="col-md-5">\n            <div class="form-group">\n              <div class="well well-sm">\n                <image-select name="image" style="height: 100%;" section="shopfeaturegroup" alt="0" size="50" value="{item.image}"></image-select>\n              </div>\n            </div>\n          </div>\n          <div class="col-md-7">\n            <div class="form-group {has-error: error.name}">\n              <label class="control-label">Наименование</label>\n              <input class="form-control" name="name" type="text" value="{item.name}">\n              <div class="help-block">{error.name}</div>\n            </div>\n            <div class="form-group {has-error: error.description}">\n              <label class="control-label">Описание</label>\n              <textarea class="form-control" rows="3" name="description" style="min-width: 100%; max-width: 100%;" value="{item.description}"></textarea>\n              <div class="help-block">{error.description}</div>\n            </div>\n          </div>\n        </div>\n      </form>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit}" type="button">Сохранить</button>\n    </yield>\n\n  </bs-modal>\n', '', '', function(opts) {
'use strict';

var self = this;

self.on('mount', function () {
    var modal = self.tags['bs-modal'];

    modal.mixin('validation');
    modal.mixin('change');

    modal.item = {};

    modal.rules = {
        name: 'empty'
    };

    modal.afterChange = function (e) {
        modal.error = modal.validation.validate(modal.item, modal.rules, e.target.name);
    };

    if (opts.id) {
        modal.loader = true;

        API.request({
            object: 'FeatureGroup',
            method: 'Info',
            data: { id: opts.id },
            success: function success(response) {
                modal.item = response;
            },
            complete: function complete() {
                modal.loader = false;
                modal.update();
            }
        });
    }
});
});


// WEBPACK FOOTER //
// ./pages/products/parameters/parameter-group-new-modal.tag